module.exports = __webpack_public_path__ + "img/comment2.a2b8c1ee.png";